import { render, staticRenderFns } from "./MarkupsModal.vue?vue&type=template&id=f0cc3758"
import script from "./MarkupsModal.vue?vue&type=script&lang=js"
export * from "./MarkupsModal.vue?vue&type=script&lang=js"
import style0 from "./MarkupsModal.vue?vue&type=style&index=0&id=f0cc3758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports